/**
 * DealMetricCard - Card de métrica estilo dashboard
 * Valor grande, label pequeno, visual premium
 * 
 * Versão: 1.0.0
 */
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

// Props do componente
interface DealMetricCardProps {
  icon?: LucideIcon;
  label: string;
  value: React.ReactNode;
  subValue?: string;
  className?: string;
  variant?: 'default' | 'primary' | 'success' | 'warning';
}

// Variantes visuais
const variantClasses = {
  default: 'bg-muted/30',
  primary: 'bg-primary/5',
  success: 'bg-emerald-50 dark:bg-emerald-900/20',
  warning: 'bg-amber-50 dark:bg-amber-900/20',
};

/**
 * Card de métrica para dashboard do deal
 */
export function DealMetricCard({ 
  icon: Icon,
  label,
  value,
  subValue,
  className,
  variant = 'default'
}: DealMetricCardProps) {
  return (
    <div
      className={cn(
        'rounded-lg p-3 space-y-1',
        variantClasses[variant],
        className
      )}
    >
      <div className="flex items-center gap-1.5">
        {Icon && <Icon className="h-3 w-3 text-muted-foreground" />}
        <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
          {label}
        </span>
      </div>
      <div className="text-lg font-bold leading-none">{value}</div>
      {subValue && (
        <span className="text-[10px] text-muted-foreground">{subValue}</span>
      )}
    </div>
  );
}
